// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

const isAuthenticated = async () => {
  return !!localStorage.getItem('accessToken')
};

const ProtectedRoute = ({ children }) => {
  const accessToken = isAuthenticated()
  return accessToken ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
